import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconUIComponent } from '../icon/icon.component';
import { IconsInitConfigType } from '../../../constants/icon.constants';

@Component({
  selector: 'fr8bot-ui-global-alert',
  imports: [IconUIComponent],
  templateUrl: './global-alert.component.html',
  styleUrl: './global-alert.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalAlertUIComponent {
  readonly iconName = input<IconsInitConfigType>('info-32');
  readonly title = input('');
  readonly description = input('');
}
